import storeFactory from '@/helpers/storeFactory'
import { format } from 'date-fns'
import orderBy from 'lodash.orderby'

export default storeFactory({
  model: {
    event_uuid: null,
    duty_date: format(new Date(), 'yyyy-MM-dd'),
    train_number: null,
    from: null,
    to: null
  },
  state: {
    places: []
  },
  getters: {
    advertisedPlaces(state) {
      return orderBy(
        state.places.map(x => {
          return {
            delay: x.delay_minutes,
            advertised: x.advertised,
            short_name: x.location,
            stop_name: x.location_long_name
          }
        }),
        ['advertised'],
        ['asc']
      )
    },

    newItemsCount() {
      return 0
    },

    missingItemsCount() {
      return 0
    },

    diffItemsCount(state, getters) {
      return getters['newItemsCount'] + getters['missingItemsCount']
    }
  }
})
